module.exports = __webpack_public_path__ + "assets/img/34_952_big.34f87924.jpg";